import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9ae86770"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import {
  IonApp,
  IonPage,
  IonContent,
  IonButton,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonMenu,
  IonMenuToggle,
  IonNote,
  IonRouterOutlet,
  IonSplitPane,
  alertController
} from '@ionic/vue';
import { ref } from 'vue';
import {
  documentTextOutline,
  documentTextSharp,
  ticketOutline,
  ticketSharp,
  albumsOutline,
  albumsSharp,
  homeOutline,
  homeSharp,
  newspaperOutline,
  newspaperSharp,
  trashOutline,
  trashSharp,
  warningOutline,
  warningSharp,
  peopleOutline,
  peopleSharp,
  
} from 'ionicons/icons';

import { useStore } from 'vuex'
import {computed} from 'vue';
import {useRouter} from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultLayout',
  setup(__props) {

const selectedIndex = ref(0);
const appPages = [
  {
    title: 'Dashboard',
    url: '/dashboard',
    iosIcon: homeOutline,
    mdIcon: homeSharp,
  },
  {
    title: 'News',
    url: '/news',
    iosIcon: newspaperOutline,
    mdIcon: newspaperSharp,
  },
  {
    title: 'Certificazioni',
    url: '/certifications',
    iosIcon: documentTextOutline,
    mdIcon: documentTextSharp,
  },
  {
    title: 'Convenzioni',
    url: '/affiliations',
    iosIcon: ticketOutline,
    mdIcon: ticketSharp,
  },
  {
    title: 'Skillcard',
    url: '/skillscards',
    iosIcon: albumsOutline,
    mdIcon: albumsSharp,
  },
  // {
  //   title: 'Soci',
  //   url: '/search',
  //   iosIcon: peopleOutline,
  //   mdIcon: peopleSharp,
  // },
  // {
  //   title: 'TBD',
  //   url: '/folder/Trash',
  //   iosIcon: trashOutline,
  //   mdIcon: trashSharp,
  // },
  // {
  //   title: 'Spam',
  //   url: '/folder/Spam',
  //   iosIcon: warningOutline,
  //   mdIcon: warningSharp,
  // },
];
const labels = ['Family', 'Friends', 'Notes', 'Work', 'Travel', 'Reminders'];

const store = useStore();
const router = useRouter();

const user = computed(() => store.getters.getUserData);
const currentRoutePath = computed(() => store.getters.getRouteCurrentPath);

const path = window.location.pathname.split('/')[1];
console.log('path', path);
if (path !== undefined) {
  selectedIndex.value = appPages.findIndex((page) => page.title.toLowerCase() === path.toLowerCase());
}

async function logout(){
  const alert =  await alertController.create({
    header: 'Attenzione',
    message: 'Sei sicuro di voler uscire?',
    buttons: [
      {
        text: 'Annulla',
        role: 'cancel',
      },
      {
        text: 'Si',
        role: 'logout',
        handler(){
          router.push({name: 'login'});
          store.commit('RESET_STATE');
        },
      }],
  });
  await alert.present();
  // console.log(event.detail.role);
  // router.push({name: 'login'});
  // store.commit('RESET_STATE');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonSplitPane), {
        "content-id": "app-content",
        when: "xl"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonMenu), {
            "content-id": "app-content",
            type: "overlay"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonContent), null, {
                default: _withCtx(() => [
                  _hoisted_1,
                  _createVNode(_unref(IonList), { id: "inbox-list" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonListHeader), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(user.value?.nome + ' ' + user.value?.cognome), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonNote), null, {
                        default: _withCtx(() => [
                          _createTextVNode("Socio N°" + _toDisplayString(user.value ? user.value.codaica : 'N.D.'), 1)
                        ]),
                        _: 1
                      }),
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(appPages, (p, i) => {
                        return _createVNode(_unref(IonMenuToggle), {
                          "auto-hide": "false",
                          key: i
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonItem), {
                              "router-direction": "root",
                              lkey: p.url,
                              "router-link": p.url,
                              lines: "none",
                              detail: "false",
                              class: _normalizeClass(["hydrated clickable", { selected: currentRoutePath.value.indexOf(p.url) === 0 }])
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonIcon), {
                                  "aria-hidden": "true",
                                  slot: "start",
                                  ios: p.iosIcon,
                                  md: p.mdIcon
                                }, null, 8, ["ios", "md"]),
                                _createVNode(_unref(IonLabel), null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(p.title), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["lkey", "router-link", "class"])
                          ]),
                          _: 2
                        }, 1024)
                      }), 64))
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonList), { id: "labels-list" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonItem), {
                        lines: "none",
                        class: "clickable"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonButton), {
                            size: "big",
                            fill: "clear",
                            onClick: logout
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Logout")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(), _createBlock(_unref(IonRouterOutlet), {
            id: "app-content",
            key: _ctx.$router.fullPath
          }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})